export default "/_next/static/images/824553fd8786cea74fc8bf7347a1a419.png";